<div
  *ngIf="!fieldAttribute.hidden"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
>
  <label
    *ngIf="fieldAttribute.backendAttribute.label"
    [for]="fieldAttribute.id"
    class="form-label label"
    [ngClass]="fieldAttribute.elementStyles.labelStyle"
    (click)="$event.preventDefault()"
  >
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
    <div
      *ngIf="isMobileView && isShowInfoTooltip"
      class="ms-1 custom-tooltip"
      data-test-id="info-tooltip"
      placement="bottom auto"
      [ngbTooltip]="fieldAttribute.backendAttribute.placeholder | translate"
      triggers="click:blur"
    >
      <img src="assets/icons/icon-info.svg" alt="info" />
    </div>
  </label>
  <div class="input-container">
    <input
      [class.is-invalid]="isFieldInvalid()"
      [ngClass]="fieldAttribute.elementStyles.contentStyle"
      [id]="fieldAttribute.id"
      [attr.data-test-id]="fieldAttribute.elementDataTestId"
      [type]="fieldAttribute.backendAttribute.type_attribute"
      [placeholder]="(isMobileView ? newPlaceholder : fieldAttribute.backendAttribute.placeholder) | translate"
      (blur)="updateValue()"
      [disabled]="fieldAttribute.disabled"
      #geocomplete
    />
    <ng-container *ngIf="hasControlValue()">
      <button
        type="button"
        [attr.data-test-id]="'clear-button-' + fieldAttribute.elementDataTestId"
        [disabled]="fieldAttribute.disabled"
        class="btn btn-link clear-button"
        (click)="clearField()"
      >
        <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
      </button>
    </ng-container>
  </div>
  <small
    *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
    class="d-flex mt-1 invalid-feedback"
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
  >
    {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
  </small>
</div>
